export default {
  ar() {
    return {
      giftNumber: 'الهدية رقم {number}',
      instructions: 'إضغط على الرابط / الروابط بالأسفل لإختيار هديتك في سباق {eventName} :'
    }
  },

  de() {
    return {
      giftNumber: 'Geschenk {number}',
      instructions: 'Bitte klicken Sie auf die nachstehenden Links, um Ihr Geschenk auszuwählen:'
    }
  },

  en() {
    return {
      giftNumber: 'Gift {number}',
      instructions: 'Please click the below link(s) to choose your gift:'
    }
  },

  enGB() {
    return {
      giftNumber: 'Gift {number}',
      instructions: 'Please click the below link(s) to choose your gift:'
    }
  },

  esMX() {
    return {
      giftNumber: 'Regalo {number}',
      instructions: 'Por favor haga clic en el enlace(s) a continuación para elegir su regalo:'
    }
  },

  fr() {
    return {
      giftNumber: 'Cadeau {number}',
      instructions: 'Cliquez sur le(s) lien(s) pour choisir votre cadeau :'
    }
  },

  it() {
    return {
      giftNumber: 'Omaggio {number}',
      instructions: 'Clicca sul collegamento sottostante per scegliere l\'omaggio che desideri ricevere:'
    }
  },

  ja() {
    return {
      giftNumber: 'ギフト {number}',
      instructions: '以下のリンクをクリックして、ギフトを選択してください'
    }
  },

  pl() {
    return {
      giftNumber: 'upominek {number}',
      instructions: 'Proszę kliknąć w poniższy link, żeby wybrać upominek dla siebie:'
    }
  },

  zhCN() {
    return {
      giftNumber: '礼物{number}',
      instructions: '请点击以下链接选择您的礼品：'
    }
  }
}
